import { useQuery } from "@tanstack/react-query"

import { useCustomerContext, useGetCustomer } from "@unlikelystudio/react-ecommerce-hooks"
import { ProductCardProps } from '~/components/UI/ProductCard'
import { fetchWishlistProducts } from '~/data/serialize-wishlist-products'


import useLocale from '~/hooks/useLocale'
import { useWishlistCookie } from "~/hooks/wishlist/useWishlistCookie"
import { getWishlist } from '~/lib/handle-api'
import type { FetchListWithContentsPayload } from "~/lib/swym/wishlist/types"

export type WishlistProduct = {
  product: ProductCardProps
  wishlistProductId: string
  variantId: string
  tags: string[]
  wishlistDetails?: ProductCardProps['wishlistDetails']
}

export type WishlistResponse = {
  wishlistLid: string
  products: WishlistProduct[]
  userInfo: FetchListWithContentsPayload["list"]["userinfo"]
}

export function useWishlistQueryKey() {
  const { data: profile } = useGetCustomer()
  const { wishlistCookie } = useWishlistCookie()

  return ["wishlist", { customerId: profile?.id, listID: wishlistCookie?.lid }]
}

export function useGetWishList() {
  const wishListQueryKey = useWishlistQueryKey()
  const { cookieFromQuery } = useWishlistCookie()
  const { customerAccessToken } = useCustomerContext()
  const locale = useLocale()


  return useQuery<WishlistResponse, unknown, WishlistResponse, typeof wishListQueryKey>(
    wishListQueryKey,
    async () => {
      const response: FetchListWithContentsPayload = await getWishlist({ accessToken: customerAccessToken, payload: cookieFromQuery })
      const products = await fetchWishlistProducts({ productFields: response?.list?.listcontents, locale })


      return {
        wishlistLid: response?.list?.lid,
        products,
        userInfo: response?.list?.userinfo,
      }
    },
    {
      enabled: Boolean(customerAccessToken && cookieFromQuery?.regid),
    }
  )
}
